(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["compatible-product-list"] && !Shopify.designMode) return;
  try {
    const loadCompatibleProductIndex = (indexUrl) => {
    if (!window.__compatibleProductIndex) {
      window.__compatibleProductIndex = fetchCompatibleProductIndex(indexUrl).catch((error) => {
        window.__compatibleProductIndex = null;
        throw error;
      });
    }

    return window.__compatibleProductIndex;
  };

  const fetchCompatibleProductIndex = async (indexUrl) => {
    const byId = new Map();
    const first = await fetchCompatibleProductPage(indexUrl, 1);
    first.products.forEach((product) => byId.set(String(product.id), product));

    const pages = Math.min(first.pages || 1, 40);

    for (let page = 2; page <= pages; page += 4) {
      const batch = [];

      for (let current = page; current < page + 4 && current <= pages; current += 1) {
        batch.push(fetchCompatibleProductPage(indexUrl, current));
      }

      const results = await Promise.all(batch);
      results.forEach((result) => {
        result.products.forEach((product) => byId.set(String(product.id), product));
      });
    }

    return [...byId.values()];
  };

  const fetchCompatibleProductPage = async (indexUrl, page) => {
    const url = new URL(indexUrl, window.location.origin);
    url.searchParams.set('page', String(page));
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('Unable to load compatible products');
    }

    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = doc.querySelector('#CompatibleProductsIndex');

    if (!node) {
      throw new Error('Unable to load compatible products');
    }

    return JSON.parse(node.content?.textContent || node.textContent);
  };

  const pickCompatibleProducts = (products, element) => {
    const targets = new Set(element.dataset.targetIds.split(',').filter(Boolean));
    const excluded = new Set((element.dataset.excludeIds || '').split(',').filter(Boolean));
    const limit = Number(element.dataset.limit) || 5;

    if (!targets.size) {
      return [];
    }

    const matches = products.filter((product) => {
      if (excluded.has(String(product.id))) {
        return false;
      }

      return (product.fits || []).some((fitId) => targets.has(String(fitId)));
    });

    for (let index = matches.length - 1; index > 0; index -= 1) {
      const swap = Math.floor(Math.random() * (index + 1));
      [matches[index], matches[swap]] = [matches[swap], matches[index]];
    }

    return matches.slice(0, limit);
  };

  const upgradeCustomElements = (root) => {
    [...root.querySelectorAll('[is]')].reverse().forEach((node) => {
      const is = node.getAttribute('is');

      if (!customElements.get(is)) {
        return;
      }

      const upgraded = document.createElement(node.localName, { is });
      [...node.attributes].forEach((attribute) => upgraded.setAttribute(attribute.name, attribute.value));

      while (node.firstChild) {
        upgraded.append(node.firstChild);
      }

      node.replaceWith(upgraded);
    });
  };

  if (!customElements.get('compatible-product-list')) {
    customElements.define('compatible-product-list', class extends HTMLElement {
      async connectedCallback() {
        if (this.dataset.loaded === 'true') {
          return;
        }

        this.dataset.loaded = 'true';

        try {
          const products = await loadCompatibleProductIndex(this.dataset.indexUrl);

          if (!this.isConnected) {
            return;
          }

          const matches = pickCompatibleProducts(products, this);

          if (!matches.length) {
            return;
          }

          this.renderMatches(matches);
          this.removeAttribute('hidden');
        } catch (error) {
          this.dataset.loaded = 'false';
        }
      }

      renderMatches(matches) {
        const stack = this.dataset.stack === 'true';
        const blends = this.dataset.blends === 'true';
        const mount = this.dataset.layout === 'cart' ? document.createElement('div') : this;

        if (this.dataset.layout === 'cart') {
          mount.className = 'v-stack gap-2.5 sm:gap-4';
          this.append(mount);
        }

        const showControls = !stack && matches.length > 1;
        const title = this.querySelector('template[data-title]');

        if (title || showControls) {
          const header = document.createElement('div');
          header.className = 'h-stack justify-between gap-4';

          if (title) {
            header.append(title.content.cloneNode(true));
          }

          mount.append(header);

          if (showControls) {
            const controls = document.createElement('div');
            controls.className = 'h-stack gap-2 hidden sm:flex';
            header.append(controls);
            this.appendProducts(mount, matches, blends, stack);
            controls.append(this.makeControl('prev'), this.makeControl('next'));
            return;
          }
        }

        this.appendProducts(mount, matches, blends, stack);
      }

      appendProducts(mount, matches, blends, stack) {
        const list = document.createElement('div');
        list.className = 'horizontal-product-list';
        list.classList.add(stack ? (blends ? 'border' : 'separate') : (blends ? 'divide-x' : 'separate'));

        if (stack && blends) {
          list.classList.add('divide-y', 'rounded-xs');
        }

        if (!stack && matches.length < 2) {
          list.classList.add('full-width');
        }

        list.innerHTML = matches.map((product) => product.html).join('');
        upgradeCustomElements(list);

        if (stack) {
          mount.append(list);
          return;
        }

        const carousel = document.createElement('scroll-carousel');
        carousel.id = this.dataset.carouselId;
        carousel.setAttribute('selector', '.horizontal-product');
        carousel.className = `horizontal-product-list-carousel scroll-area bleed${blends ? '' : ' separate'}${this.dataset.layout === 'product' ? ' sm:unbleed' : ''}`;
        carousel.append(list);
        mount.append(carousel);
      }

      makeControl(type) {
        const definedName = type === 'prev' ? 'prev-button' : 'next-button';
        const button = customElements.get(definedName)
          ? document.createElement('button', { is: definedName })
          : document.createElement('button');
        const carousel = this.querySelector('scroll-carousel');

        button.type = 'button';
        button.className = 'circle-chevron hover:colors';
        button.setAttribute('aria-controls', this.dataset.carouselId);
        button.setAttribute('aria-label', type === 'prev' ? this.dataset.prevLabel : this.dataset.nextLabel);

        if (type === 'prev') {
          button.disabled = true;
        }

        const icon = this.querySelector(`template[data-icon="${type}"]`);

        if (icon) {
          button.append(icon.content.cloneNode(true));
        }

        if (!customElements.get(definedName) && carousel) {
          const position = type === 'prev' ? 'start' : 'end';
          button.addEventListener('click', () => {
            carousel.dispatchEvent(new CustomEvent(type === 'prev' ? 'control:prev' : 'control:next', { bubbles: true, cancelable: true }));
          });
          carousel.addEventListener('scroll:edge-nearing', (event) => {
            if (event.detail.position === position) {
              button.disabled = true;
            }
          });
          carousel.addEventListener('scroll:edge-leaving', (event) => {
            if (event.detail.position === position) {
              button.disabled = false;
            }
          });
        }

        return button;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
